import styled from 'styled-components';

export const Container = styled.div`
    && {
        display: flex;
        gap: 10px;
        overflow: auto hidden;
        flex-wrap: nowrap;

        /* scrollbar styling */
        scrollbar-width: thin;
        scrollbar-color: ${({ theme }) => theme.shades.white[10]} transparent;

        ::-webkit-scrollbar-track {
            background: transparent;
        }
        ::-webkit-scrollbar-thumb {
            background: ${({ theme }) => theme.shades.white[10]};
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            flex-wrap: wrap;
            margin: 0 0 10px 0;
            padding-bottom: 10px;
        }
    }
`;

export const SortItem = styled.span<{ active?: boolean }>`
    && {
        width: fit-content;
        white-space: nowrap;
        font-family: 'Alliance No.1';
        font-style: normal;
        font-weight: 700;
        font-size: 0.875rem;
        line-height: 1.42857143;
        letter-spacing: -0.2px;
        text-align: center;
        color: ${({ theme }) => theme.colors.white};

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        border-radius: 24px;
        transition: background 0.2s ease;
    }
`;
